import { ChatMessage } from '@ant-design/pro-chat';
import { DefaultMessage } from '@ant-design/pro-chat/es/ProChat/components/ChatList/Messages/Default';
import { ReactNode } from 'react';

interface TextMessageProps {
  msg: ChatMessage | null;
  editableContent?: ReactNode;
}

const TextMessage: React.FC<TextMessageProps> = ({ msg, editableContent }) => {
  if (!msg) {
    return null;
  }
  return msg.content === '...' ? null : (
    <DefaultMessage
      id={msg.id}
      content={msg.content}
      role={msg.role}
      createAt={msg.createAt}
      updateAt={msg.updateAt}
      editableContent={editableContent}
    />
  );
};

export default TextMessage;
